/* eslint-disable vue/no-unused-vars */
<template>
  <div class="subscribers">
    <a-card
      :headStyle="{ marginBottom: '0', paddingBottom: '0', minHeight: '40px' }"
      :bodyStyle="{ paddingTop: '3px' }"
      class="card"
    >
      <div slot="title" class="subscriber-list-head-title">
        <a-input-search
          placeholder="Buscar nombre, email, dni, etc"
          class="filter-input"
          @search="onSearch"
        />
      </div>
      <div slot="extra" class="extraStyle">
        <a-dropdown placement="bottomCenter" style="margin-right:1rem">
          <a class="ant-dropdown-link">
            <span class="order-by-label"> Ordenar por: </span
            >{{ orderBySelection }} <a-icon type="down"
          /></a>
          <a-menu slot="overlay" @click="handleOrderByClick">
            <a-menu-item key="startDate">Fecha de Alta</a-menu-item>
            <a-menu-item key="firstName">Nombre</a-menu-item>
            <a-menu-item key="lastName">Apellido</a-menu-item>
            <a-menu-item key="DNI">DNI</a-menu-item>
            <a-menu-item key="email">Email</a-menu-item>
          </a-menu>
        </a-dropdown>
        <a-dropdown placement="bottomCenter">
          <a class="ant-dropdown-link">
            <span class="status-label">Estado: </span
            >{{ statusFilterSelection }} <a-icon type="down"
          /></a>
          <a-menu slot="overlay" @click="handleStatusFilterClick">
            <a-menu-item key="">Todos</a-menu-item>
            <a-menu-item key="100">Activo</a-menu-item>
            <a-menu-item key="200">Inactivo</a-menu-item>
            <a-menu-divider />
            <a-menu-item key="1">Alta</a-menu-item>
            <a-menu-item key="5">Período de Pruebas</a-menu-item>
            <a-menu-item key="2">Baja Manual</a-menu-item>
            <a-menu-item key="3">Baja Falta de Pago</a-menu-item>
            <a-menu-item key="4">Suscripción Expirada</a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
      <div v-if="displayEmptyMessage" style="margin-top:2rem">
        <h5 style="color:#555;">No se registran suscriptos.</h5>
      </div>
      <div
        class="demo-infinite-container"
        v-infinite-scroll="loadMore"
        :infinite-scroll-disabled="scrollDisabled"
        :infinite-scroll-distance="15"
        infinite-scroll-event-target="window"
      >
        <a-list :dataSource="listData" size="large">
          <a-list-item
            slot="renderItem"
            slot-scope="item"
            key="item.subscriptionId"
          >
            <a-list-item-meta>
              <div
                v-if="
                  (item.status == '1' || item.status == '5') &&
                    item.lastFailedDebitAttempt
                "
                slot="avatar"
                :class="$style.avatarDiv"
              >
                <div :class="$style.avatarWithId">
                  <a-avatar :class="$style.yellow" icon="user" />
                </div>
                <span :class="[$style.idBox, $style.yellow]"
                  >#{{ item.customer.id }}
                </span>
              </div>

              <div
                v-else-if="item.status == '1'"
                slot="avatar"
                :class="$style.avatarDiv"
              >
                <div :class="$style.avatarWithId">
                  <a-avatar :class="$style.green" icon="user" />
                </div>
                <span :class="[$style.idBox, $style.green]"
                  >#{{ item.customer.id }}
                </span>
              </div>

              <div
                v-else-if="item.status == '5'"
                slot="avatar"
                :class="$style.avatarDiv"
              >
                <div :class="$style.avatarWithId">
                  <a-avatar :class="$style.blue" icon="user" />
                </div>
                <span :class="[$style.idBox, $style.blue]"
                  >#{{ item.customer.id }}
                </span>
              </div>

              <div v-else slot="avatar" :class="$style.avatarDiv">
                <div :class="$style.avatarWithId">
                  <a-avatar :class="$style.pink" icon="user" />
                </div>
                <span :class="[$style.idBox, $style.pink]"
                  >#{{ item.customer.id }}
                </span>
              </div>

              <h4 slot="title">
                <router-link
                  :key="'view'"
                  :to="
                    `/subscriptions/${subscriptionId}/subscribers/${item.customer.id}`
                  "
                >
                  <strong
                    v-if="orderBySelection == 'Apellido'"
                    style="font-weight:normal"
                  >
                    {{ item.customer.lastName }},
                    {{ item.customer.firstName }}
                  </strong>
                  <span v-else style="font-weight:normal">
                    {{ item.customer.firstName }}
                    {{ item.customer.lastName }}
                  </span>
                </router-link>
                <span style="font-size:10px">&nbsp;</span>
                <span
                  v-if="
                    (item.status == '1' || item.status == '5') &&
                      item.lastFailedDebitAttempt
                  "
                >
                  <a-tooltip
                    :title="
                      `Falló el pago el día ${$moment(
                        item.lastFailedDebitAttempt
                      ).format('DD/MM/YYYY')} (${
                        item.consecutiveFailureAttempts
                      } intentos fallidos). El último período pagado fue ${$moment(
                        item.lastPeriodPaid
                      ).format('DD/MM/YYYY')}.`
                    "
                    placement="right"
                    ><a-tag color="orange">Pago Pendiente</a-tag>
                  </a-tooltip>
                </span>
                <span v-else-if="item.status == '1'">
                  <a-tooltip
                    :title="
                      `Período vigente del ${$moment(
                        item.lastPeriodPaid
                      ).format('DD/MM')} al ${$moment(item.lastPeriodPaid)
                        .add(1, 'month')
                        .format('DD/MM')}.`
                    "
                    placement="right"
                    ><a-tag color="green">Activo</a-tag>
                  </a-tooltip>
                </span>
                <span v-else-if="item.status == '5'">
                  <a-tooltip
                    :title="
                      `Se encuentra en período de pruebas del ${$moment(
                        item.startDate
                      ).format('DD/MM')} hasta el ${$moment(item.startDate)
                        .add(item.subscription.freeTrialDays, 'day')
                        .format('DD/MM')}.`
                    "
                    placement="right"
                    ><a-tag color="blue">Período de Prueba</a-tag>
                  </a-tooltip>
                </span>
                <span v-else-if="item.status == '2'">
                  <a-tooltip
                    v-if="item.endDate"
                    :title="
                      `El cliente fue dado de baja el día ${$moment(
                        item.endDate
                      ).format('DD/MM')}`
                    "
                    placement="right"
                    ><a-tag color="pink">Baja Manual</a-tag>
                  </a-tooltip>
                  <a-tag v-else color="pink">Baja Manual</a-tag>
                </span>
                <span v-else-if="item.status == '3'">
                  <a-tooltip
                    v-if="item.endDate"
                    :title="
                      `El cliente fue dado de baja el día ${$moment(
                        item.endDate
                      ).format('DD/MM')} luego de ${
                        item.consecutiveFailureAttempts
                      } intentos fallidos de cobro.`
                    "
                    placement="right"
                    ><a-tag color="pink">Baja Automática</a-tag>
                  </a-tooltip>
                  <a-tag v-else color="pink">Baja Automática</a-tag>
                </span>
                <span v-else-if="item.status == '4'">
                  <a-tooltip
                    v-if="item.endDate"
                    :title="
                      `El cliente fue dado de baja el día ${$moment(
                        item.endDate
                      ).format('DD/MM')} porque la suscripción expiró.`
                    "
                    placement="right"
                    ><a-tag color="pink">Suscripción Expirada</a-tag>
                  </a-tooltip>
                  <a-tag v-else color="pink">Suscripción Expirada</a-tag>
                </span>
              </h4>
              <div slot="description">
                <strong v-if="orderBySelection == 'DNI'">
                  DNI: {{ item.customer.DNI }}
                  <br />
                </strong>
                <!--<span v-else> DNI: {{ item.customer.DNI }} <br /></span>-->

                <span v-if="item.customer.phone1">
                  <a
                    :href="'https://wa.me/' + item.customer.phone1"
                    target="_blank"
                    ><i class="icmn-whatsapp" />&nbsp;{{
                      item.customer.phone1
                    }}</a
                  >
                  |
                </span>
                <a :href="'mailto:' + item.customer.email">
                  <strong v-if="orderBySelection == 'Email'">
                    {{ item.customer.email }}</strong
                  >
                  <span v-else>
                    {{ item.customer.email }}
                  </span>
                </a>
                |
                <span> Alta: {{ item.createdAt | moment("DD/MM") }} </span>
                <!--
                |
                <span style="white-space:nowrap">
                  Pagó: {{ $moment(item.lastPeriodPaid).format("DD/MM/YYYY") }}
                </span>
                -->
                <!--
                <br />
                <a
                  target="_blank"
                  href="https://api.whatsapp.com/send?phone=5491149395995"
                  >Call Lucas</a
                >-->
              </div>
            </a-list-item-meta>
            <!--
            <a-button>Content</a-button>
            -->
            <!--
            <a slot="actions"
              ><i class="icmn-user-minus" /> Finalizar Suscripción</a
            >
            <a slot="actions"><i class="icmn-coin-dollar" /> Cobro Manual</a>
-->
            <template slot="actions">
              <!--
                <span :key="type">
                <a-icon :type="type" style="margin-right: 8px" />
                {{ text }}
              </span>
              -->
              <router-link
                :key="'edit'"
                :to="
                  `/subscriptions/${subscriptionId}/subscribers/${item.customer.id}/edit`
                "
                ><i :class="'icmn-credit-card'" /> Medio de Pago
              </router-link>
              <!--
              <router-link
                :key="'run-recurrent-payment-process'"
                :to="
                  `/subscriptions/${subscriptionId}/subscriber/${item.customer.id}`
                "
                ><i :class="'icmn-coin-dollar'" /> Cobro Manual
              </router-link>
              -->
              <a-spin v-if="loadingUnsubscribe[item.customer.id]" />
              <span v-else>
                <a
                  @click="handleUnsubscribe(item)"
                  v-if="item.status == '1' || item.status == '5'"
                  ><i :class="'icmn-user-minus'" /> Baja
                </a>
                <a v-else @click="handleActivate(item)"
                  ><i :class="'icmn-user-plus'" /> Alta
                </a>
              </span>
            </template>
          </a-list-item>

          <a-skeleton
            :loading="loadingData"
            :paragraph="{ rows: 1, width: '100%' }"
            active
            :title="false"
            style="margin-top:2rem"
          />
          <a-skeleton
            :loading="loadingData"
            :paragraph="{ rows: 1, width: '100%' }"
            active
            :title="false"
          />
          <a-skeleton
            :loading="loadingData"
            :paragraph="{ rows: 1, width: '100%' }"
            active
            :title="false"
          />
        </a-list>
      </div>
    </a-card>
  </div>
</template>
<script>
//import { data } from "./data.json";
import { mapActions } from "vuex";
import store from "@/store";
import infiniteScroll from "@/services/vue-infinite-scroll";
//import { RecycleScroller } from "vue-virtual-scroller";

export default {
  name: "subscribersList",
  directives: { infiniteScroll },
  /*components: {
    "virtual-scroller": RecycleScroller
  },*/
  data() {
    return {
      pagination: {
        position: "bottom"
      },
      loadingData: false,
      loadingUnsubscribe: [],
      loadingRecurrentPayment: false,
      scrollDisabled: false,
      displayEmptyMessage: false,
      listData: [],
      statusFilterSelection: "Activo",
      orderBySelection: "Fecha de Alta"
    };
  },
  props: ["subscriptionId"],
  methods: {
    ...mapActions({
      loadSubscribers: "subscribers/load",
      unsubscribe: "subscribers/unsubscribe",
      activate: "subscribers/activate"
    }),
    async handleUnsubscribe(item) {
      try {
        //console.log("params:", params);
        if (!this.loadingUnsubscribe[item.customer.id]) {
          this.loadingUnsubscribe[item.customer.id] = true;
          const result = await this.unsubscribe({
            subscriptionId: this.subscriptionId,
            subscriberId: item.customer.id
          });
          if (result) {
            item.status = "2";
            this.loadingUnsubscribe[item.customer.id] = false;
            this.$notification["success"]({
              message: "Exito",
              description: "Se dio de baja la suscripción."
            });
          }
        }
      } catch (error) {
        this.loadingUnsubscribe[item.customer.id] = false;
        this.$notification["warning"]({
          message: error.code,
          description: error.message
        });
      }
    },
    async handleActivate(item) {
      try {
        //console.log("params:", params);
        if (!this.loadingUnsubscribe[item.customer.id]) {
          this.loadingUnsubscribe[item.customer.id] = true;
          const result = await this.activate({
            subscriptionId: this.subscriptionId,
            subscriberId: item.customer.id
          });
          if (result) {
            item.status = "1";
            this.loadingUnsubscribe[item.customer.id] = false;
            this.$notification["success"]({
              message: "Exito",
              description: "Se reactivó la suscripción."
            });
          }
        }
      } catch (error) {
        this.loadingUnsubscribe[item.customer.id] = false;
        this.$notification["warning"]({
          message: error.code,
          description: error.message
        });
      }
    },
    async fetchSubscribersData() {
      try {
        //console.log("params:", params);
        if (!this.loadingData) {
          this.loadingData = true;
          this.displayEmptyMessage = false;
          const result = await this.loadSubscribers({
            subscriptionId: this.subscriptionId
          });
          if (store.state.subscribers.results.length > 0) {
            store.state.subscribers.results.forEach(item => {
              this.loadingUnsubscribe[item.customer.id] == false;
            });
            this.listData = this.listData.concat(
              store.state.subscribers.results
            );
          } else this.displayEmptyMessage = true;

          this.loadingData = false;
        }
      } catch (error) {
        this.loadingData = false;
        if (error.status == 404) this.displayEmptyMessage = true;
        else {
          this.$notification["warning"]({
            message: error.code,
            description: error.message
          });
        }
      }
    },
    async loadMore() {
      try {
        if (
          //todavia hay registros para bajar
          this.$store.state.subscribers.totalResults >
          this.$store.state.subscribers.page *
            this.$store.state.subscribers.pageSize
        ) {
          this.scrollDisabled = true;
          this.$nprogress.start();
          const result = await this.fetchSubscribersData();
          this.scrollDisabled = false;
          this.$nprogress.done();
        }
        return;
      } catch (error) {
        this.scrollDisabled = false;
        this.$nprogress.done();
        this.$notification["failure"]({
          message: "Error",
          description: `Hubo un error al cargar el listado. Disabled: ${this.scrollDisabled}`
        });
      }
    },
    handleStatusFilterClick(event) {
      this.statusFilterSelection = event.item.$el.innerHTML;
      this.$store.commit("subscribers/SET_STATUS_ID", event.key);
      this.$store.commit("subscribers/SET_RESET_PAGE");
      this.listData = [];
      this.scrollDisabled = false;
      //this.loadMore();
      this.fetchSubscribersData(true);
    },
    handleOrderByClick(event) {
      this.orderBySelection = event.item.$el.innerHTML;
      this.$store.commit("subscribers/SET_ORDER_BY", event.key);
      this.$store.commit("subscribers/SET_RESET_PAGE");
      this.listData = [];
      this.scrollDisabled = false;
      //this.loadMore();
      this.fetchSubscribersData(true);
    },
    onSearch(keyword) {
      this.$store.commit("subscribers/SET_SEARCH", keyword);
      this.$store.commit("subscribers/SET_RESET_PAGE");
      this.listData = [];
      this.scrollDisabled = false;
      //this.loadMore();
      this.fetchSubscribersData(true);
    }
    /*
    async addRecord() {
      try {
        const newData = [...this.tableData];
        const target = newData.filter(item => "+" === item.id)[0];
        if (target) {
          console.log("params:", params);
          this.loading = true;
          const params = {
            name: target.name,
            amount: target.amount,
            frequencyId: target.frequencyId,
            endDate: target.endDate,
            freeTrialDays: target.freeTrialDays,
            costCenterId: target.costCenter.id,
            businessUnitId: target.businessUnit.id
          };
          const result = await this.addSubscription(params);
          delete target.editable;
          delete target.add;
          const result2 = await this.fetchTableData();
        }
      } catch (error) {
        this.loading = false;
        this.$notification["warning"]({
          message: error.code,
          description: error.message
        });
      }
    },
    async saveRecord(key) {
      try {
        const newData = [...this.tableData];
        const target = newData.filter(item => key === item.id)[0];
        if (target) {
          //console.log("params:", params);
          this.loading = true;
          const params = {
            id: target.id,
            name: target.name,
            amount: target.amount,
            frequencyId: target.frequencyId,
            endDate: target.endDate,
            freeTrialDays: target.freeTrialDays,
            costCenterId: target.costCenter.id,
            businessUnitId: target.businessUnit.id,
            status: target.status
          };
          const result = await this.saveSubscription(params);
          this.tableData = newData;
          delete target.editable;
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
        this.$notification["warning"]({
          //NOTA IMPORTANTE: el debugger de chrome no muestra el error object pero llega.
          message: error.response.status,
          description: error.response.data.data[0]
        });
      }
    },
    async deleteRecord(key) {
      try {
        const newData = [...this.tableData];
        const target = newData.filter(item => key === item.id)[0];
        if (target) {
          this.loading = true;
          const result = await this.deleteSubscription(key);
          this.tableData = newData.filter(item => item.id !== key);
          this.loading = false;
        }
      } catch (error) {
        //this.$nprogress.done();
        this.loading = false;
        this.$notification["warning"]({
          message: error.code,
          description: error.message
        });
      }
    }*/
  },
  created() {
    //window.addEventListener("touchmove", this.handleInfiniteOnLoad);
    /*window.onscroll = () => {
      this.$notification["success"]({
        message: "In infinite load",
        description: `Disabled: ${this.scrollDisabled}`
      });
      if (
        document.documentElement.scrollTop + window.innerHeight ===
        document.documentElement.offsetHeight
      ) {
        this.loadMore();
      }
    };*/
  },
  mounted() {
    this.$store.commit("subscribers/SET_RESET_DATA");
    this.fetchSubscribersData();
  },
  //it's run when actived in keep-alive mode
  activated() {
    //si el listado fue actualizado en otro componente
    if (this.$store.state.subscribers.listUpdated) {
      this.listData = [];
      this.$store.commit("subscribers/SET_RESET_PAGE");
      this.$store.commit("subscribers/SET_LIST_UPDATED", false);
      this.fetchSubscribersData();
    }
  }
};
</script>

<style lang="scss" module>
@import "./index.module.scss";
.editable-row-operations a {
  margin-right: 8px;
}
</style>

<style lang="css">
.demo-loading-container {
  position: absolute;
  bottom: 50%;
  width: 100%;
  text-align: center;
}
.ant-list-item-action {
  margin-top: 1rem;
}
.ant-dropdown-link {
  text-transform: none;
  font-weight: normal;
}
.ant-card-head {
}
.ant-card-extra,
.ant-card-head-title {
}
.subscriber-list-head-title {
  padding-top: -3px;
}
strong {
  color: black;
  font-weight: bold;
}
.filter-input {
  width: 200px;
}
@media (max-width: 767px) {
  .order-by-label,
  .status-label {
    display: none;
  }
  .filter-input {
    width: 160px;
  }
}
</style>
